<template>
  <base-dialog-prompt
    :model-value="boundValue"
    @update:model-value="emitBoundValue"
    :max-width="!onlyBgColor ? '640px' : '400px'"
  >
    <template v-slot:title>
      <p class="text-center w-100">{{ prompt }}</p>
    </template>
    <template v-slot:content>
      <v-row
          class="color-picker ma-0"
          justify="center"
      >
        <v-col
            cols="12"
            :sm="!onlyBgColor ? 'auto' : 12"
            class="color-picker__col"
        >
          <p
              v-if="!onlyBgColor"
              class="text-center text-subtitle-1"
          >Background color:</p>
          <v-color-picker
              class="mx-auto"
              hide-inputs
              mode="hex"
              elevation="0"
              :model-value="bgColor"
              @update:model-value="$emit('bgColor', $event)"
              :swatches="bgSwatches"
              show-swatches
          ></v-color-picker>
        </v-col>
        <v-col
            v-if="!onlyBgColor"
            cols="12"
            sm="auto"
            class="color-picker__col"
        >
          <p class="text-center text-subtitle-1">Text color:</p>
          <v-color-picker
              class="mx-auto"
              hide-inputs
              mode="hex"
              elevation="0"
              :model-value="textColor"
              @update:model-value="$emit('textColor', $event)"
              :swatches="textSwatches"
              show-swatches
          ></v-color-picker>
        </v-col>
      </v-row>
    </template>
    <template v-slot:actions>
      <v-btn
        :color="resetColor"
        variant="flat"
        class="text-white"
        @click="resetSettings()"
      >{{ resetText }}</v-btn>
      <v-spacer></v-spacer>
      <v-btn
        :color="cancelColor || undefined"
        :class="{ 'v2-btn-has-bg': !cancelColor }"
        @click="cancel()"
      >{{ cancelText }}</v-btn>
      <v-spacer></v-spacer>
      <v-btn
        :color="confirmColor"
        variant="flat"
        class="text-white"
        @click="confirm()"
      >{{ confirmText }}</v-btn>
    </template>
  </base-dialog-prompt>
</template>

<script>
import modelValueCompat from '@/mixins/modelValueCompat';

export default {
  name: 'BaseDialogColorPicker',

  mixins: [modelValueCompat],

  inheritAttrs: false,

  props: {
    value: {},
    prompt: {
      type: String,
      default: "Do you really want to proceed?",
    },
    confirmText: {
      type: String,
      default: "Select",
    },
    cancelText: {
      type: String,
      default: "Cancel",
    },
    confirmColor: {
      type: String,
      default: "primary",
    },
    cancelColor: {
      type: String,
      default: "",
    },
    resetText: {
      type: String,
      default: "Reset",
    },
    resetColor: {
      type: String,
      default: "red",
    },
    bgColor: {
      type: String,
      default: '#FFFFFF',
    },
    textColor: {
      type: String,
      default: '#000000',
    },
    onlyBgColor: {
      type: Boolean,
      default: false,
    }
  },

  emits: ['update:modelValue', 'input', 'confirm', 'cancel', 'reset', 'bgColor', 'textColor'],

  data() {
    return {
      bgSwatches: [
        ['#FF0000', '#E91E63', '#9C27B0'],
        ['#FFFF00', '#FFC107', '#FF5722'],
        ['#00FF00', '#00AA00', '#00695C'],
        ['#00FFFF', '#00BCD4', '#009688'],
      ],
      textSwatches: [
        ['#212121',],
        ['#FAFAFA',],
      ],
    }
  },

  methods: {

    confirm: function () {
      this.$emit('confirm');
    },

    cancel: function () {
      this.emitBoundValue(null);
      this.$emit('cancel');
    },

    resetSettings: function () {
      this.$emit('reset');
    },
  },
};
</script>

<style>
/* Match master: modest gap between side-by-side 300px pickers (V2 grid gutters). */
.color-picker.v-row > .color-picker__col {
  padding: 8px 12px;
  flex-grow: 0;
}

.color-picker .v-color-picker-swatches__swatch .v-color-picker-swatches__color {
  border: 1px solid #080808;
}
.theme--dark .color-picker .v-color-picker-swatches__swatch .v-color-picker-swatches__color,
.v-theme--dark .color-picker .v-color-picker-swatches__swatch .v-color-picker-swatches__color {
  border-color: #f5f5f5;
}
</style>
